<template>
  <div class="row">
    <div class="col-12" v-if="data_user.type.name == 'Helper' || data_user.type.name == 'Majikan'">
      <div class="mb-3">
        <span v-if="data_user.type.name == 'Helper'">
          <button class="btn btn-primary mr-3" :enabled="data_user.set_publish_at == null" @click="change_publish">Set {{ data_user.is_publish == 1 ? 'Non Active' : 'Active' }}</button>
          <!-- <button class="btn btn-primary ml-3" v-if="data_user.is_sign_up_paid == 0" @click="complete_signup">Complete Signup</button> -->
          <button class="btn btn-primary mr-3" :disabled="data_user.phone_verified_at != null" @click="bypass_otp">Bypass OTP process</button>
          <button class="btn btn-primary mr-3" :disabled="data_user.is_verified == 1" @click="bypass_verify">Bypass Verify process</button>
        </span>
        <button class="btn btn-primary mr-3" :disabled="data_user.firebase_token.length == 0" @click="force_login">Force Login</button>
      </div>
      <div class="mb-3" v-show="!is_allow_edit">
        <button class="btn btn-primary mr-3" v-if="data_user.is_suspend == 0" @click="suspend">Suspend User</button>
        <button class="btn btn-primary mr-3" v-if="data_user.is_suspend == 1" @click="suspend">Unsuspend User</button>
      </div>
      <div class="row">
        <div class="col-12 col-lg-4" v-if="this.$route.query.id != null && !is_allow_edit">
          <img width="100%" :src="data_user.arr_picture.length > 0 ? image_primary_from_server() : ''" class="mb-3" v-show="data_user.arr_picture.length > 0"/>
          <status-profile :data="data_user" v-if="data_user.type.name == 'Helper'"/>
          <result-test-profile :data="data_user" v-if="data_user.type.name == 'Helper'"/>
        </div>
        <div class="col-12" :class="{'col-lg-8': !is_allow_edit}">
          <profile-info-1 :data="data_user" :is_allow_edit="is_allow_edit" @on_birth_date_change="on_birth_date_change"/>
          <profile-info-2 :data="data_user" :is_allow_edit="is_allow_edit"/>
          <general-info :data="data_user" :is_allow_edit="is_allow_edit" v-if="data_user.type.name == 'Helper'"/>
          <skill
            :data="data_user"
            :is_allow_edit="is_allow_edit"
            :skill_arr="skill_arr"
            @on-select="on_select_skill"
            v-if="data_user.type.name == 'Helper'"/>
          <work-at
            :data="data_user"
            :is_allow_edit="is_allow_edit"
            :city_arr="city_arr"
            @on-select="on_select_work"
            v-if="data_user.type.name == 'Helper'"/>
          <upload-user-photo
            :data="data_user"
            :is_allow_edit="is_allow_edit"
            @on-add-picture="on_add_picture"
            @on-delete-picture="on_delete_picture"
            @on-set-as-primary="on_set_as_primary"/>
          <!-- <contact-info :data="data_user" :is_allow_edit="is_allow_edit"/> -->
          <job-info :data="data_user" v-show="this.$route.query.id != null && !is_allow_edit"/>
          <upload-id-card :data="data_user" :is_allow_edit="is_allow_edit" @on-add-picture="on_add_id_card"/>
        </div>
        <div class="form-group col-12 text-right">
          <button type="button" class="btn btn-danger" v-show="is_allow_edit" @click="toggle_edit_user">Cancel</button>
          <button type="button" class="btn btn-primary" v-show="is_allow_edit" data-toggle="modal" data-target="#preloader_modal" @click="save">Save</button>

          <button type="button" class="btn btn-primary" v-show="!is_allow_edit" @click="toggle_edit_user">Edit</button>
        </div>
      </div>
    </div>
    <div class="col-12" v-else>
      <profile-info-1 :data="data_user" :is_allow_edit="is_allow_edit" @on_birth_date_change="on_birth_date_change"/>
      <div class="form-group text-right">
        <button type="button" class="btn btn-danger" v-show="is_allow_edit" @click="toggle_edit_user">Cancel</button>
        <button type="button" class="btn btn-primary" v-show="is_allow_edit" data-toggle="modal" data-target="#preloader_modal" @click="save">Save</button>

        <button type="button" class="btn btn-primary" v-show="!is_allow_edit" @click="toggle_edit_user">Edit</button>
      </div>
    </div>
  </div>
</template>

<script>
import {MDCChipSet} from '@material/chips'

import upload_user_photo from '@/pages/user/user_component/upload_user_photo'
import result_test_profile from '@/pages/user/user_component/result_test_profile'
import status_profile from '@/pages/user/user_component/status_profile'
import profile_info_1 from '@/pages/user/user_component/profile_info_1'
import profile_info_2 from '@/pages/user/user_component/profile_info_2'
import general_info from '@/pages/user/user_component/general_info'
import skill from '@/pages/user/user_component/skill'
import work_at from '@/pages/user/user_component/work_at'
// import contact_info from '@/pages/user/component/contact_info'
import job_info from '@/pages/user/user_component/job_info'
import upload_id_card from '@/pages/user/user_component/upload_id_card'

export default {
  components:{
    'upload-user-photo': upload_user_photo,
    'general-info': general_info,
    'profile-info-1': profile_info_1,
    'profile-info-2': profile_info_2,
    'job-info': job_info,
    // 'contact-info': contact_info,
    'upload-id-card': upload_id_card,
    'result-test-profile': result_test_profile,
    'status-profile': status_profile,
    skill,
    'work-at': work_at,
  },
  props: {
    data: {
      type: Object,
    },
    is_edited: {
      type: Boolean,
    }
  },
  watch: {
    data: {
      immediate: true,
      async handler(new_val,old_val){
        this.data_user = JSON.parse(JSON.stringify(this.data))
        await this.get_skill_data()
        await this.get_city_data()
      },
    },
    is_edited(val){
      if(val)
        this.is_allow_edit = !this.is_allow_edit
    }
  },
  data(){
    return{
      data_user: JSON.parse(JSON.stringify(this.data)),
      is_allow_edit: this.$route.query.id != null ? false : true,
      skill_arr: [],
      city_arr: [],
    }
  },
  async mounted(){
    await this.get_skill_data()
    await this.get_city_data()
  },
  methods:{
    image_primary_from_server(){
      var picture = {}
      for(let x in this.data_user.arr_picture){
        if(this.data_user.arr_picture[x].is_primary == 1){
          picture = this.data_user.arr_picture[x]
          break
        }
      }

      return base_url+'/images/user?file_name='+picture.file_name
    },
    image_from_server(file_name){
      return base_url+'/images/user?file_name='+file_name
    },
    async get_skill_data(){
      var response = await axios.get(base_url+'/skill/all')

      var response_data = response.data

      if(response_data.status == "success"){
        for(let x in response_data.data){
          var counter = 0
          for(let y in this.data_user.arr_skill){
            if(this.data_user.arr_skill[y].id == response_data.data[x].id){
              response_data.data[x].selected = true
              break
            }
            counter++
          }

          if(counter == this.data_user.arr_skill.length)
            response_data.data[x].selected = false
        }
        this.skill_arr = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
    async get_city_data(){
      var response = await axios.get(base_url+'/city/all')

      var response_data = response.data

      if(response_data.status == "success"){
        for(let x in response_data.data){
          var counter = 0
          for(let y in this.data_user.arr_work_at){
            if(this.data_user.arr_work_at[y].id == response_data.data[x].id){
              response_data.data[x].selected = true
              break
            }
            counter++
          }

          if(counter == this.data_user.arr_work_at.length)
            response_data.data[x].selected = false
        }
        this.city_arr = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
    toggle_edit_user(){
      if(this.$route.query.id != null){
        this.is_allow_edit = !this.is_allow_edit
        this.data_user = JSON.parse(JSON.stringify(this.data))
      }
      else
        location.href = "/user"
    },
    save(){
      var arr_selected_skill = []
      for(let x in this.skill_arr){
        if(this.skill_arr[x].selected)
          arr_selected_skill.push(this.skill_arr[x])
      }
      this.data_user.selected_skill = arr_selected_skill

      var arr_selected_city = []
      for(let x in this.city_arr){
        if(this.city_arr[x].selected)
          arr_selected_city.push(this.city_arr[x])
      }
      this.data_user.selected_work_at = arr_selected_city

      this.$emit('on-save',this.data_user)
    },
    change_publish(){
      this.$emit('on-change-publish')
    },
    complete_signup(){
      this.$emit('on-complete-signup')
    },
    bypass_otp(){
      this.$emit('on-bypass-otp')
    },
    bypass_verify(){
      this.$emit('on-bypass-verify')
    },
    force_login(){
      if(confirm('Are you sure?\nThis action means user must re-login again'))
        this.$emit('on-force-login')
    },
    suspend(){
      this.$emit('on-suspend')
    },
    on_add_picture(picture){
      for(let x = 0; x < picture.length; x++){
        var is_primary = 1
        for(let y = 0; y < this.data_user.arr_picture.length; y++){
          if(this.data_user.arr_picture[y].is_primary == 1){
            is_primary = 0
            break
          }
        }

        var data = {}
        data.is_primary = is_primary
        data.picture = URL.createObjectURL(picture[x])
        this.data_user.arr_picture.push(data)
      }
      this.data_user.is_change_picture = true
      // console.log(this.data_user)
      // this.data_user.name = 'ashkdhjasdh'
    },
    on_add_id_card(picture){
      this.data_user.id_card = URL.createObjectURL(picture)
      this.data_user.is_change_id_card = true
    },
    on_delete_picture(index){
      this.data_user.arr_picture.splice(index,1)
      this.data_user.is_change_picture = true
    },
    on_set_as_primary(index){
      for(let x in this.data_user.arr_picture){
        var picture = this.data_user.arr_picture[x]
        picture.is_primary = 0
        this.$set(this.data_user.arr_picture,x,picture)
      }

      var picture = this.data_user.arr_picture[index]
      picture.is_primary = 1
      this.$set(this.data_user.arr_picture,index,picture)

      this.data_user.is_change_picture = true
    },
    on_select_skill(index){
      var data = this.skill_arr[index]
      data.selected = !data.selected
      this.$set(this.skill_arr,index,data)
    },
    on_select_work(index){
      var data = this.city_arr[index]
      data.selected = !data.selected
      this.$set(this.city_arr,index,data)
    },
    on_birth_date_change(value){
      // console.log(value)
      this.data_user.birth_date = value.format('YYYY-MM-DD')
    }
  }
}
</script>

<style>
  .mdc-chip-set--filter .mdc-chip.mdc-chip--selected, .mdc-chip-set--filter .mdc-chip.mdc-chip--selected:hover{
    background-color: #1266f1;
    color: white;
  }
  .mdc-chip-set--filter .mdc-chip.mdc-chip--selected .mdc-chip__ripple::before, .mdc-chip-set--filter .mdc-chip.mdc-chip--selected .mdc-chip__ripple::after{
    background-color: white;
  }
</style>
